"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_BOX = exports.BACKGROUND_IMAGE = void 0;
const IMAGE_BOX = exports.IMAGE_BOX = 'image-box';
const BACKGROUND_IMAGE = exports.BACKGROUND_IMAGE = 'background-image';
